module.exports = __webpack_public_path__ + "static/media/background-2-1920w.128682d3.webp";